import type { RewardOffer } from "byzantine/src/dbbl/businessLogic/entities/cardLinkedOffers";
import CompactOfferRow from "../CompactOfferRow";

import styles from "./CompactOffersGrid.module.scss";

interface CompactOffersGridProps {
  offers: RewardOffer[];
  maxOffers?: number;
  className?: string;
  onOfferClick: (offerId: string) => void;
  expanded?: boolean;
}

const CompactOffersGrid = ({
  offers,
  maxOffers,
  className,
  onOfferClick,
  expanded = false,
}: CompactOffersGridProps) => {
  const limitedOffers = maxOffers ? offers.slice(0, maxOffers) : offers;

  const handleOfferClick = (offerId: string) => {
    onOfferClick(offerId);
  };

  // Determine which items should not have bottom border
  // Remove border from last element of each column
  const shouldRemoveBorder = (index: number) => {
    const totalItems = limitedOffers.length;

    // In a 2-column grid:
    // - If total items is odd, the last item (index = totalItems - 1) should have no border
    // - If total items is even, the last 2 items should have no border (last in each column)

    if (totalItems % 2 === 0) {
      // Even number of items: remove border from last 2 items
      return index >= totalItems - 2;
    } else {
      // Odd number of items: remove border from last item only
      return index === totalItems - 1;
    }
  };

  return (
    <div
      className={
        className ? `${styles.offersGrid} ${className}` : styles.offersGrid
      }
      data-testid="compact-offers-grid"
    >
      {limitedOffers.map((offer, index) => (
        <CompactOfferRow
          key={offer.id}
          offer={offer}
          onClick={handleOfferClick}
          removeBorder={shouldRemoveBorder(index)}
          expanded={expanded}
        />
      ))}
    </div>
  );
};

export default CompactOffersGrid;
